export function scrollTopPage() {

    /**
     * On page change scroll top
     */
    window.scrollTo(0, 0);
}

export function scrollTo(target: HTMLElement) {
    target.scrollIntoView();
}

export function setPageTitle (title?: string) {
    if(title) {
        document.title = title;
    }
}

export function setFavicon (favicon?: string) {
    if (favicon) {
        let link = document.createElement('link');
        let apple = document.createElement('link');
        link.rel = 'icon';
        apple.rel = 'apple-touch-icon';
        document.head.appendChild(link);
        document.head.appendChild(apple);
        link.href = favicon;
        apple.href = favicon;
    }
}